import { GRADE_LABELS, GRADE_SAMPLES } from "./game/config";
import type { Grade } from "./types";
import type { AuthUser } from "./auth/types";

export function $(sel: string, root: ParentNode = document): HTMLElement {
  return root.querySelector(sel) as HTMLElement;
}

export function headerHtml(user: AuthUser | null, route: string): string {
  const account = user
    ? `<a class="nav-link${route === "account" ? " is-on" : ""}" href="#/account">${esc(user.nickname)}</a>`
    : `<a class="nav-link${route === "account" ? " is-on" : ""}" href="#/account">Sign in to Play</a>`;
  return `<header class="site-head">
    <a class="wordmark" href="../index.html" title="Orangecat Digital home">
      <span class="cat-dot" aria-hidden="true"></span>
      Orangecat Digital
    </a>
    <nav class="nav">
      <a class="nav-link" href="../index.html">Projects</a>
      ${account}
    </nav>
  </header>`;
}

export function starsHtml(n: number): string {
  const on = Math.max(0, Math.min(3, n | 0));
  return `<span class="stars" aria-label="${on} of 3 stars">${[0, 1, 2]
    .map((i) => `<span class="star${i < on ? " is-on" : ""}">★</span>`)
    .join("")}</span>`;
}

export function gradeTiles(selected?: Grade): string {
  return (Object.keys(GRADE_LABELS) as unknown as Grade[])
    .map((g) => {
      const gg = Number(g) as Grade;
      return `<button type="button" class="grade-tile${selected === gg ? " is-on" : ""}" data-grade="${gg}">
        <span class="g-k">${GRADE_LABELS[gg]}</span>
        <span class="g-s">${GRADE_SAMPLES[gg]}</span>
      </button>`;
    })
    .join("");
}

export function fmtTime(ms: number): string {
  const s = Math.max(0, Math.round(ms / 1000));
  const m = Math.floor(s / 60);
  const r = s % 60;
  return m ? `${m}:${String(r).padStart(2, "0")}` : `${r}s`;
}

export function fmtClock(ms: number): string {
  const s = Math.max(0, Math.ceil(ms / 1000));
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}:${String(r).padStart(2, "0")}`;
}

export function esc(s: string): string {
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

export function toast(root: HTMLElement, msg: string): void {
  const el = document.createElement("div");
  el.className = "combo-toast";
  el.textContent = msg;
  root.appendChild(el);
  setTimeout(() => el.remove(), 1600);
}
